import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import iconSuper from "../../../../assets/images/event-2024/super-icon.png";
import { PATHS } from "@config/constants";
import { ID_TAB_EVENT_2024 } from "@config/constants/helper";

export default function GiftSupper({ statusEvent, handleOpenGift = null, classItem = "" }) {
  const history = useHistory();

  const handleGoChristmasTree = () => {
    history.push(`${PATHS.EVENT}/${ID_TAB_EVENT_2024.christmasTree}`);
  };

  return (
    <div
      className={`super-icon ${classItem || ""}`}
      onClick={handleOpenGift || handleGoChristmasTree}
    >
      <img src={iconSuper} alt="" />
      <div className="number-gift">{statusEvent?.open_left || 0}</div>
      <div className="number-super">{statusEvent?.open_super_left || 0}</div>
    </div>
  );
}
